import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument";
import axios from "axios";

const sendGuestText = async (text, token, prefix) => {
  try {
    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return "";
    }

    const url = `${prefix}image-generation`;
    const body = {
      text: text,
    };

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    // use axios
    // don(t use formdata

    const response = await axios.post(url, body, {
      headers: headers,
    });

    if (response.status === 200 && response.data?.url) {
      return response.data.url;
    } else {
      console.error(
        "Unexpected response status or structure:",
        response.status,
        response.data
      );
      return "";
    }
  } catch (error) {
    console.error(`Error in sendGuestSignature: ${error.message}`);
    return "";
  }
};

export default sendGuestText;
